
































// @ is an alias to /src
import { Vue, Component, Prop } from 'vue-property-decorator';


@Component({
  name: 'DroppoButton',
  components: {
  },
})
export default class DroppoButton extends Vue {
  @Prop({ default: '' })
  private readonly topText!: string;

  @Prop({ default: '' })
  private readonly bottomText!: string;

  @Prop({ default: true })
  private readonly filled!: boolean;

  @Prop({ default: "100%"})
  private readonly textWidth!: boolean;

  @Prop({ default: "#F6EB14" })
  private readonly fontColor!: string;

  @Prop({ default: false })
  private readonly fillWidth!: boolean;

}
